import { render, staticRenderFns } from "./InstanceSettings.vue?vue&type=template&id=63ed642b&scoped=true&"
import script from "./InstanceSettings.vue?vue&type=script&lang=js&"
export * from "./InstanceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed642b",
  null
  
)

export default component.exports